import { SocialAccount } from "./publish-models";

/** Provides the list of connected destinations (social accounts / CDN). Replace with real API later. */
export abstract class IDestinationsProvider {
  abstract getDestinations(): SocialAccount[];
}
